import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import MainLayout from 'layout/main';
import { UserSelector } from 'state/user';
import { AppSelector } from 'state/app';
import { APP_VERSION } from 'config/app.config';

const PrivateRoute = ({ component: Component, location, roles, ...rest }) => {
  const token = useSelector(UserSelector.getUserToken);
  const userRoles = useSelector(UserSelector.getUserRoles);
  const userAppVersion = useSelector(AppSelector.getAppVersion);

  return APP_VERSION === userAppVersion &&
    token &&
    userRoles &&
    roles.some((x) => userRoles.includes(x)) ? (
    <Route
      {...rest}
      render={(props) => (
        <MainLayout>
          <Component {...props} />
        </MainLayout>
      )}
    />
  ) : (
    <Redirect
      to={{
        pathname: '/',
        state: { from: location },
      }}
    />
  );
};
PrivateRoute.propTypes = {
  component: PropTypes.any,
  location: PropTypes.object,
};

export default PrivateRoute;
